export default function logoSetRows(el: HTMLElement) {
  const logos: NodeListOf<HTMLElement> = el.querySelectorAll(".logo-set-item")

  function adjustLogoRows() {
    const logosArray = Array.from(logos).reverse()
    logosArray.forEach((logo, index) => {
      // Check if logo is in the first row
      if (
        logo.getBoundingClientRect().top >
          logosArray[logosArray.length - 1].getBoundingClientRect().top &&
        index >= 0
      ) {
        logo.classList.add("border-t", "border-black-20")
      } else {
        logo.classList.remove("border-t", "border-black-20")
      }

      // Check if logo is the last logo of the row
      if (
        index < logosArray.length - 1 &&
        logo.getBoundingClientRect().top >
          logosArray[index + 1].getBoundingClientRect().top
      ) {
        logosArray[index + 1].classList.add("flex-grow")
      } else if (
        index < logosArray.length - 1 &&
        logo.getBoundingClientRect().top <=
          logosArray[index + 1].getBoundingClientRect().top
      ) {
        logosArray[index + 1].classList.remove("flex-grow")
      }
    })
  }

  // Ensure page has loaded before call the function for the first time
  window.addEventListener("load", () => {
    adjustLogoRows()
  })

  window.addEventListener("resize", adjustLogoRows)
}
